module.exports = __webpack_public_path__ + "img/banner-empty.3680591d.png";